import { onDeliveryAddressSelectedAction } from '~/src/features/domofon/purchase/actions/onDeliveryAddressSelected';
import onDeliveryAddressSelection from '~/src/features/domofon/purchase/actions/onDeliveryAddressSelection';
import EEquipmentPurchaseActions from '~/src/features/domofon/purchase/constants/actions';
import { InitialState } from '~/src/features/domofon/purchase/reducer/initialState';

export type TDeliveryMethodReducerActions =
    | typeof onDeliveryAddressSelectedAction
    | typeof onDeliveryAddressSelection

const deliveryMethodReducer = (
    state: InitialState,
    action: ReturnType<TDeliveryMethodReducerActions>,
): InitialState => {
    switch (action.type) {
        case EEquipmentPurchaseActions.DELIVERY_ADDRESS_SELECTION: {
            return {
                ...state,
                isDeliveryAddressSelection: action.payload,
            };
        }
        case EEquipmentPurchaseActions.DELIVERY_ADDRESS_SELECTED: {
            return {
                ...state,
                isDeliveryAddressSelection: false,
                selectedDeliveryAddress: action.payload,
            };
        }
    }
};

export default deliveryMethodReducer;
